/**
 * Tailwind CSS implementation of CharacterCounter component
 * Uses Seeds character-counter CSS classes from character-counter.css
 */

import * as React from "react";
import type { TypeCharacterCounterProps } from "./CharacterCounterTypes";

// Utility for merging class names properly
function cn(
  ...inputs: (string | undefined | null | false | Record<string, boolean>)[]
): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === "string") {
      classes.push(input);
    } else if (typeof input === "object") {
      for (const [key, value] of Object.entries(input)) {
        if (value) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(" ");
}

export const CharacterCounterTailwind = React.forwardRef<
  HTMLDivElement,
  TypeCharacterCounterProps
>(
  (
    {
      currentValue,
      maxValue,
      size = "default",
      mode = "countdown",
      className,
      ...rest
    },
    ref
  ) => {
    const remaining = maxValue - currentValue;
    const displayValue = mode === "countup" ? currentValue : remaining;
    const classes = cn(
      "seeds-character-counter",
      { "seeds-character-counter-mini": size === "mini" },
      { "seeds-character-counter-overlimit": remaining < 0 },
      className
    );
    return (
      <div
        {...(rest as React.HTMLAttributes<HTMLDivElement>)}
        ref={ref}
        role="status"
        className={classes}
      >
        {displayValue}
      </div>
    );
  }
);

CharacterCounterTailwind.displayName = "CharacterCounterTailwind";
